import { api } from '../../app/api/baseApi';

const ontologyApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAllDeviceCategories: builder.mutation({
            query: (params) => ({
                params,
                method: 'GET',
                url: `/ontology/v1/models/category`,
            }),
            transformResponse: (response) => {
                const responseClone = JSON.parse(JSON.stringify(response));
                responseClone.data = responseClone?.data?.map((item: any) => ({
                    id: item,
                    name: item,
                }));

                return responseClone;
            },
        }),
        getModelCategories: builder.query({
            query: (params) => ({
                url: `/ontology/v1/models/category`,
                method: 'GET',
                params: {
                    ...params,
                    category: 'CATEGORY',
                },
            }),
            transformResponse: (response: any) => {
                const responseClone = JSON.parse(JSON.stringify(response));
                responseClone.data = responseClone?.data?.map((item: any) => ({
                    id: item,
                    name: item,
                }));

                return responseClone;
            },
        }),
        getDeviceModelsByCategory: builder.mutation({
            query: (params) => ({
                url: `/ontology/v1/models`,
                method: 'GET',
                params,
            }),
        }),
        configurechannels: builder.mutation({
            query: ({ payload, deviceTypeId, realmPrefix }: any) => ({
                url: `ontology/v1/channels/${deviceTypeId}/configure`,
                method: 'PATCH',
                body: payload,
                ...(realmPrefix && { headers: { 'x-realm': realmPrefix } }),
            }),
            invalidatesTags: (result, error): any => (!error ? ['DEVICEMODELS'] : []),
        }),

        getAllDeviceModels: builder.query({
            query: () => ({
                params: {
                    category: 'MODEL',
                },
                url: `/ontology/v1/models/category`,
            }),
        }),
        getDeviceModels: builder.query({
            query: ({ body, params, realmPrefix }) => ({
                url: `ontology/v1/models/filter`,
                method: 'POST',
                body,
                ...(params && {
                    params: params,
                }),
                ...(realmPrefix && { headers: { 'x-realm': realmPrefix } }),
            }),
            providesTags: ['DEVICEMODELS'],
        }),

        getLoadTrendConfiguration: builder.query<any, any>({
            query: (body) => ({
                url: `/ontology/v1/load-trend/configuration`,
                method: 'POST',
                ...(body && { body: body }),
            }),
        }),
        getLoadTrendUnits: builder.query<any, any>({
            query: (deviceTypeIds) => ({
                url: `/ontology/v1/load-trend/configuration/units/devicetypeids`,
                method: 'POST',
                body: deviceTypeIds,
            }),
        }),
    }),
});

export const {
    useGetModelCategoriesQuery,
    useGetDeviceModelsQuery,
    useGetAllDeviceModelsQuery,
    useConfigurechannelsMutation,
    useGetAllDeviceCategoriesMutation,
    useGetDeviceModelsByCategoryMutation,
    useGetLoadTrendUnitsQuery,
    useLazyGetLoadTrendUnitsQuery,
    useGetLoadTrendConfigurationQuery,
    useLazyGetLoadTrendConfigurationQuery,
} = ontologyApi;
